import React from 'react'
import Layout from './src/components/Layout/Layout'
import { PageTransitionProvider } from './src/context/PageTransitionContext'
import { AccessibilityProvider } from './src/context/AccessibilityContext'
import PageTransitionOverlay from './src/components/PageTransitionOverlay'

// NOTE: the provider wrapping order (PageTransitionProvider →
// AccessibilityProvider) MUST match gatsby-ssr.js `wrapRootElement`.
// If they diverge, the React tree differs between SSR and hydration,
// causing hydration mismatches and losing context state on first paint.
// Keep these two files in sync whenever adding/removing providers.
export const wrapRootElement = ({ element }) => {
  return (
    <PageTransitionProvider>
      <AccessibilityProvider>
        {element}
        <PageTransitionOverlay />
      </AccessibilityProvider>
    </PageTransitionProvider>
  )
}

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}

// Alias framework-specific wrappers to framework-agnostic data attributes
// so e2e tests survive the Next.js migration without selector churn.
const tagFrameworkAgnosticHooks = () => {
  document.body.dataset.hydrated = 'true'
  document.querySelectorAll('.gatsby-resp-image-wrapper').forEach((el) => {
    el.setAttribute('data-responsive-image', '')
  })
  document.querySelectorAll('.gatsby-highlight').forEach((el) => {
    el.setAttribute('data-code-block', '')
  })
}

export const onInitialClientRender = () => {
  tagFrameworkAgnosticHooks()
}

export const onRouteUpdate = () => {
  tagFrameworkAgnosticHooks()
}

// trigger an immediate page refresh when an update is found
export const onServiceWorkerUpdateReady = () => window.location.reload()
